<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <div class="pull-left">
                                    <h4 class="card-title float-left">{{fitment.fitmentType === 'JEWELRY' ? $t("fitment.titleJewelry") : $t("fitment.title")}}</h4>
                                </div>
                                <!--<div class="form-group pull-right mr-5" v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">-->
                                    <!--&lt;!&ndash;<button class="all-btn" @click="getFitmentDataApi()">&ndash;&gt;-->
                                        <!--&lt;!&ndash;oling.uz&ndash;&gt;-->
                                    <!--&lt;!&ndash;</button>&ndash;&gt;-->
                                    <!--<button class="all-btn clear-btn ml-5" @click="clearAnalog()">-->
                                        <!--<i class="fa fa-remove"></i>-->
                                    <!--</button>-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="row" v-if="fitment.appraisalStatusEnum === 'Rejected'">
                            <div class="col">
                                <div class="alert alert-danger">
                                    <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган..
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">

                                <div class="form-group">
                                    <label>{{$t("fitment.name")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="fitment.name"
                                           :class="{invalid : $v.fitment.name.$error}"/>
                                    <div class="red" v-if="$v.fitment.name.$error">Ишончнома номери
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-group">
                                        <label>
                                            Продукт тури
                                        </label>
                                        <v-select v-model="fitment.productCategoryDto.parent" label="text"
                                                  :options="productCategories"
                                                  :filterable="false"
                                                  @search="onCategorySearch"
                                                  @search:focus="onCategoryFocus"
                                                  @input="onChangeMethod">
                                            <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.text"></div>
                                            </template>
                                            <template slot="selected-option"
                                                      v-if="fitment && fitment.productCategoryDto && fitment.productCategoryDto.parent && fitment.productCategoryDto.parent.text">
                                                <div v-html="fitment.productCategoryDto.parent.text"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                            </template>
                                            <span slot="no-options">{{$t("empty")}}</span>
                                        </v-select>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label :class="$v.fitment.productCategoryDto.$error ? 'text-danger' : ''">
                                        Продукт <span class="text-danger">*</span>
                                    </label>
                                    <v-select v-model="fitment.productCategoryDto" label="text"
                                              :options="productSubCategories"
                                              :filterable="false"
                                              @search="onSubCategorySearch"
                                              @search:focus="onSubCategoryFocus"
                                              @input="onChangeMethodSub"
                                              :class="{invalid : $v.fitment.productCategoryDto.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="fitment && fitment.productCategoryDto && fitment.productCategoryDto.text">
                                            <div v-html="fitment.productCategoryDto.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("empty")}}</span>
                                    </v-select>
                                </div>

                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-7 col-6">
                                            <label>{{$t("fitment.useWebSite")}} <span class="red">*</span></label>
                                            <input type="text" class="form-control" v-model="fitment.useWebSite"
                                                   :class="{invalid : $v.fitment.useWebSite.$error}"/>
                                            <div class="red" v-if="$v.fitment.useWebSite.$error">
                                                {{$t("fitment.useWebSite")}}
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-6 form-check" v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                                            <label>{{$t("fitment.foreign")}}</label>
                                            <label class="form-check-label mb-2 ml-5">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="fitment.hasCustomsDuty"
                                                       @change="calculated">
                                                <span class="form-check-sign"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                                    <div class="row">
                                        <div class="col-md-7 col-6">
                                            <label :class="$v.fitment.metalType.$error ? 'red' : ''">
                                                {{$t("fitment.metalType")}}
                                                <span class="red">*</span>
                                            </label>
                                            <select class="form-control"
                                                    v-model="fitment.metalType"
                                                    @change="calculated"
                                                    :class="{invalid : $v.fitment.metalType.$error}">
                                                <option value="GOLD">{{$t("fitment.gold")}}</option>
                                                <option value="SILVER">{{$t("fitment.silver")}}</option>
                                            </select>
                                        </div>
                                        <div class="col-md-5 col-6" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                                            <label>{{$t("fitment.hallmark")}} <span class="red">*</span></label>
                                            <numeric-input class="form-control" v-model="fitment.hallmark"
                                                           :class="{invalid : $v.fitment.hallmark.$error}"
                                                           :controls="false" :precision="3"></numeric-input>
                                            <div class="red" v-if="$v.fitment.hallmark.$error">
                                                {{$t("fitment.hallmark")}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-7 col-6">
                                            <label>{{$t("fitment.qty")}} <span class="red">*</span></label>
                                            <numeric-input class="form-control" v-model="fitment.qty"
                                                           :class="{invalid : $v.fitment.qty.$error}"
                                                           :controls="false" :precision="3" @input="calculated"></numeric-input>
                                            <div class="red" v-if="$v.fitment.qty.$error">
                                                {{$t("fitment.qty")}}
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-6" v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                                            <label>
                                                <b :class="$v.fitment.unitMeasurementType.$error ? 'red' : ''">{{$t("fitment.um")}}</b>
                                                <span class="red">*</span>
                                            </label>
                                            <select class="form-control" v-model="fitment.unitMeasurementType"
                                                    :class="{invalid : $v.fitment.unitMeasurementType.$error}">
                                                <option value=""></option>
                                                <option :value="option.key" v-for="option in unitMeasurements" :key="option.key">
                                                    {{option.name}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-5 col-6" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                                            <label>
                                                <b :class="$v.fitment.weigh.$error ? 'red' : ''">{{$t("fitment.weigh")}}</b>
                                                <span class="red">*</span>
                                            </label>
                                            <numeric-input class="form-control" v-model="fitment.weigh"
                                                           :class="{invalid : $v.fitment.weigh.$error}"
                                                           :controls="false" :precision="3"></numeric-input>
                                            <div class="red" v-if="$v.fitment.weigh.$error">
                                                {{$t("fitment.weigh")}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                                    <label>{{$t("fitment.stonePrice")}} <span class="red">*</span></label>
                                    <numeric-input class="form-control" v-model="fitment.stonePrice"
                                                   :class="{invalid : $v.fitment.stonePrice.$error}"
                                                   :controls="false" :precision="0"></numeric-input>
                                    <div class="red" v-if="$v.fitment.stonePrice.$error">
                                        {{$t("fitment.stonePrice")}}
                                    </div>
                                </div>

                                <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                                    <label>{{$t("fitment.overlayCoefficient")}} <span class="red">*</span></label>
                                    <numeric-input class="form-control" v-model="fitment.overlayCoefficient"
                                                   :class="{invalid : $v.fitment.overlayCoefficient.$error}"
                                                   :controls="false" :precision="3"></numeric-input>
                                    <div class="red" v-if="$v.fitment.overlayCoefficient.$error">
                                        {{$t("fitment.overlayCoefficient")}}
                                    </div>
                                </div>


                                <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                                    <div class="row">
                                        <div class="col-md-7 col-6">
                                            <label :class="$v.fitment.governmentPrice.$error ? 'red' : ''">
                                                {{$t("fitment.price")}}
                                                <span class="red">*</span>
                                            </label>
                                            <numeric-input class="form-control" v-model="fitment.governmentPrice"
                                                           :class="{invalid : $v.fitment.governmentPrice.$error}"
                                                           :controls="false" :precision="3" @input="calculated"></numeric-input>
                                        </div>
                                        <div class="col-md-5 col-6 form-check">
                                            <label>{{$t("config.currency")}} <span class="red">*</span></label>
                                            <select class="form-control" v-model="fitment.currency"
                                                    :class="{invalid : $v.fitment.currency.$error}"
                                                    @change="calculated">
                                                <option value="UZS">UZS</option>
                                                <option value="USD">USD</option>
                                                <option value="EUR">EUR</option>
                                                <option value="RUB">RUB</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY' &&
                                     this.fitment.fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS'">
                                    <label :class="$v.fitment.dilapidationValue.$error ? 'red' : ''">
                                        {{$t("fitment.dilapidationValue")}}
                                    </label>
                                    <numeric-input class="form-control"
                                           v-model="fitment.dilapidationValue"
                                           @input="changeDilapidationValue14"
                                           :class="{invalid : $v.fitment.dilapidationValue.$error}" :precision="0"
                                    ></numeric-input>
                                    <!--<label><b class="red">14 - Стандард</b></label>-->
                                </div>

                                <div class="form-group"
                                     v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY' &&
                                     this.fitment.fitmentType === 'BUILDINGS_TRANSMITTERS_MACHINERY_EQUIPMENT'">
                                    <label :class="$v.fitment.dilapidationValue.$error ? 'red' : ''">
                                        {{$t("fitment.dilapidationValue")}}
                                        <span class="red">*</span>
                                    </label>
                                    <select class="form-control" v-model="fitment.dilapidationValue"
                                            :class="{invalid : $v.fitment.dilapidationValue.$error}"
                                            @change="changeDilapidationValue15">
                                        <option value=""></option>
                                        <option :value="option" v-for="option in dilapidation15" :key="option">
                                            {{option}}
                                        </option>
                                    </select>
                                    <!--<label><b class="red">15 - Стандард</b></label>-->
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                                    <label>{{$t("fitment.stoneName")}} </label>
                                    <input type="text" class="form-control" v-model="fitment.stoneName"/>
                                </div>

                                <div class="form-group">
                                    <label>{{fitment.fitmentType === 'JEWELRY' ? 'Заргарлик буйум бренди' : $t("fitment.brandName")}} </label>
                                    <input type="text" class="form-control" v-model="fitment.brandName"/>
                                </div>

                                <div class="form-group">
                                    <label>{{fitment.fitmentType === 'JEWELRY' ? 'Заргарлик буйум модели' : $t("fitment.model")}} </label>
                                    <input type="text" class="form-control" v-model="fitment.model"/>
                                </div>

                                <div class="form-group">
                                    <label>{{fitment.fitmentType === 'JEWELRY' ? 'Заргарлик буйум ишлаб чиққарилган мамлакат' : $t("fitment.madeCountry")}} </label>
                                    <select class="form-control" v-model="fitment.madeCountry">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in madeCountries" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY' && fitment.objectType !== 'Asset'">
                                    <label>{{$t("fitment.province")}} </label>
                                    <select class="form-control" v-model="fitment.region">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in provinces" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                                    <label>{{$t("fitment.partConditions")}} </label>
                                    <select class="form-control" v-model="fitment.conditionType">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in partConditions" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group" v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                                    <label>{{$t("fitment.madeYear")}} </label>
                                    <input type="text" class="form-control" v-model="fitment.madeYear"/>
                                </div>
                            </div>
                        </div>

                        <div class="calculate row m-1">
                            <div class="col-4">
                                <h4 class="ml-3 text-primary">
                                    <b>Харажат усулдаги қиймати:<br/></b>
                                </h4>
                                <h4 class="ml-3 text-primary">
                                    <b>{{fitment.totalGovPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм</b>
                                </h4>
                            </div>
                            <div class="col-4">
                                <span class="mr-3">
                                    Техник холати:
                                    <b>{{technicalConditionText}}<br/><br/></b>
                                </span>
                                <span class="mr-3" v-if="fitment.currency === 'USD'">
                                    Доллар курси:
                                    <b>{{fitment.usdCurrencyRate | currency('', 2, { thousandsSeparator: ' ' })}} сўм<br/><br/></b>
                                </span>
                                <span class="mr-3" v-if="fitment.currency === 'EUR'">
                                    Евро курси:
                                    <b>{{fitment.eurCurrencyRate | currency('', 2, { thousandsSeparator: ' ' })}} сўм<br/><br/></b>
                                </span>
                                <span class="mr-3" v-if="fitment.currency === 'RUB'">
                                    Рубл курси:
                                    <b>{{fitment.rubCurrencyRate | currency('', 2, { thousandsSeparator: ' ' })}} сўм<br/><br/></b>
                                </span>
                                <span v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                                    Эскириш қиймати:
                                    <b>{{fitment.dilapidationValue}} %<br/><br/></b>
                                </span>
                                <span v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                                    1 грамм соф {{fitment.metalTypeName}}нинг жаҳон бозоридаги нархи :
                                    <b>{{fitment.gramPriceInSum | currency('', 2, { thousandsSeparator: ' ' })}} сўм<br/><br/></b>
                                </span>
                                <span>
                                    Энг кам иш хакки:
                                    <b>{{minSalary | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                                </span>
                            </div>
                            <div class="col-4">
                                <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Солик ставкаси (ККС):
                                    <b>{{fitment.vat | currency('', 2, { thousandsSeparator: ' ' })}} %<br/><br/></b>
                                </span>
                                <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Транспорт харажатлари:
                                    <b>{{fitment.road | currency('', 2, { thousandsSeparator: ' ' })}} %<br/><br/></b>
                                </span>
                                <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Божхона хужжатларини расмийлаштириш:
                                    <b>{{fitment.customsClearance | currency('', 2, { thousandsSeparator: ' ' })}} {{isNewStandard ? 'сўм' : '%'}}<br/><br/></b>
                                </span>
                                <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Божхона божи:
                                    <b>{{fitment.customsDuty | currency('', 2, { thousandsSeparator: ' ' })}} %</b>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <template v-if="!isPageLoadInit">
                                <AssetDropZone code="fitmentImageDropZone" label="fitment.photos"
                                               folder="FitmentImage" :folderName="'Fitment'"
                                               :data="fitment.fitmentPictures"
                                               @change="(files) => {fitment.fitmentPictures = files}"
                                               :removeFile="canRemoveFile"
                                               :editable="canSave"
                                               :class="'col-md-12'"
                                />
                            </template>
                        </div>

                        <div class="row">
                            <template v-if="!isPageLoadInit">
                                <AssetDropZone code="texPassportDropZone" label="fitment.texPassport"
                                               folder="TexPassport" :folderName="'Fitment'"
                                               :data="fitment.fitmentTexPassports"
                                               @change="(files) => {fitment.fitmentTexPassports = files}"
                                               :removeFile="canRemoveFile"
                                               :editable="canSave"
                                               :class="'col-md-12'"
                                />
                            </template>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-12">
                                <div class="form-group">
                                    <label>{{$t("fitment.texPassportNumber")}} </label>
                                    <input type="text" class="form-control" v-model="fitment.texPassportNum"/>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("fitment.aboutTexPassport")}} </label>
                                    <textarea class="form-control" v-model="fitment.texPassportDescription"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save(null)" :disabled="processing"
                                        v-if="canSave">{{$t("action.save")}}
                                </button>
                                <!--<button class="all-btn add-btn" @click="save('SAVE_AND_CREATE_NEW')" :disabled="processing"-->
                                        <!--v-if="canSave">{{$t("action.saveAndCreateNew")}}-->
                                <!--</button>-->
                            </div>
                        </div>
                        <div class="row" v-if="fitment.appraisalStatusEnum === 'Confirmed'">
                            <div class="col">
                                <div class="alert alert-warning d-flex">
                                    <i class="fa-fw fa fa-warning mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong> Тасдиқлагандан (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш тугмасини босинг!</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FitmentApiData/>
    </div>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import AssetDropZone from '@/views/asset/AssetDropZone'
    import {required, requiredUnless} from 'vuelidate/lib/validators';
    import {UNIT_MEASUREMENT,MADE_COUNTRY,PROVINCE,PART_CONDITION,FITMENT_TYPE} from '@/shared/constants/fitment'
    import FitmentApiData from '@/views/fitment/FitmentApiData';
    import initFilterModel from '@/shared/filter';

    export default {
        name: "FitmentItemEdit",
        components: {
            AssetDropZone,
            FitmentApiData: FitmentApiData
        },
        props: {
            objectType: {
                type: String,
                default: null
            },
            parentId: {
                type: String,
                default: null
            },
            id: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                processing: false,
                numericTypes: numericTypes,
                show: false,
                isPageLoadInit: false,
                fitment: {
                    id: null,
                    parentId: this.$props.parentId,
                    objectType: this.$props.objectType,
                    productCategoryDto: {

                    },
                    conditionType: null,
                    fitmentType: null,
                    fitmentPictures: [],
                    fitmentTexPassports: [],
                    appraisalStatusEnum: 'Unreviewed',
                    parentStatus: 'Pending',
                    parentAppraisalStatusEnum: 'Unreviewed',
                    unitMeasurementType: "GRAM",
                    metalType: null,
                    metalTypeName: '',
                    qty: 0,
                    dilapidationValue: null,
                    governmentPrice: null,
                    technicalCondition: null,
                    totalGovPrice: 0,
                    stonePrice : null,
                    hallmark : null,
                    weigh : null,
                    overlayCoefficient : null,
                    useWebSite : null,
                    apiData: false,
                    hasCustomsDuty: false,
                    currency: null,
                    usdCurrencyRate: 0,
                    eurCurrencyRate: 0,
                    rubCurrencyRate: 0,
                    vat: 0,
                    road: 0,
                    customsClearance: 0,
                    customsDuty: 0,
                    gramPriceInSum: 0
                },
                unitMeasurements: UNIT_MEASUREMENT,
                dilapidation15: [0,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85,90,97.5,100],
                madeCountries: MADE_COUNTRY,
                provinces: PROVINCE,
                partConditions: PART_CONDITION,
                fitmentTypes: FITMENT_TYPE,
                metalTypes: [],
                technicalConditionText: '',
                productCategoryFilter: initFilterModel(),
                subCategoryFilter: initFilterModel(),
                productCategories: [],
                productSubCategories: [],
                minSalary: 0,
                isNewStandard: false,
                coefficient: 0,
                status: null,
                entiteCreateType: null
            }
        },
        validations() {
            return {
                fitment: {
                    productCategoryDto: {
                        id: {
                            required: required
                        }
                    },
                    useWebSite: {
                        required: requiredUnless(() => {
                            return (this.entiteCreateType === 'EXPERT2');
                        })
                    },
                    fitmentType: {
                        required: required
                    },
                    qty: {
                        required: requiredUnless(() => {
                            return (this.entiteCreateType === 'EXPERT2');
                        }),
                    },
                    name: {
                        required: required
                    },
                    unitMeasurementType: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType === 'JEWELRY');
                        })
                    },
                    governmentPrice: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType === 'JEWELRY' || this.entiteCreateType === 'EXPERT2');
                        })
                    },
                    technicalCondition: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType === 'JEWELRY' || this.entiteCreateType === 'EXPERT2');
                        })
                    },
                    dilapidationValue: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType === 'JEWELRY');
                        })
                    },
                    hallmark: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType !== 'JEWELRY');
                        })
                    },
                    weigh: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType !== 'JEWELRY');
                        })
                    },
                    metalType: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType !== 'JEWELRY');
                        })
                    },
                    stonePrice: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType !== 'JEWELRY');
                        })
                    },
                    overlayCoefficient: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType !== 'JEWELRY');
                        })
                    },
                    // fitmentPictures: {
                    //     required: requiredUnless(() => {
                    //         return this.fitment.entiteCreateType === 'EXPERT2';
                    //     }),
                    //     minLength: minLength(1)
                    // },
                    currency: {
                        required: requiredUnless(() => {
                            return (this.fitment.fitmentType === 'JEWELRY' || this.entiteCreateType === 'EXPERT2');
                        })
                    }
                }
            };
        },
        computed: {
            canSave() {
                if (this.fitment.objectType === 'Asset') {
                    return (this.status === 'Pending' || this.fitment.parentStatus === 'Pending' || this.status === 'AssignedToEvaluator' || this.status === 'NotFullyEvaluated' || this.status === 'SentToComplement');
                } else {
                    return (this.fitment.parentAppraisalStatusEnum === 'Unreviewed' || this.fitment.parentAppraisalStatusEnum === 'NotFullyEvaluated' || this.entiteCreateType === 'EXPERT2');
                }
            },
            canRemoveFile() {
                return this.status && this.status !== 'Rated' && this.status !== 'Confirmed' && this.status!=='Rejected' && this.hasPermission('NEW_FITMENT_IMAGE_DELETE')
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$props.id;
                vm.entiteCreateType = this.$route.query.entiteCreateType;
                let objectType = "Fitment";
                if (vm.fitment.objectType === 'Asset') {
                    objectType = "Asset";
                }

                const promises = [
                    vm.$http.get('fitment/metalType/' + (id ? id : 0) + '/' + vm.$props.parentId + '/' + objectType)
                ];

                if (id && id > 0) {
                    vm.isPageLoadInit = true;
                    promises.push(vm.$http.get('fitment/item/' + id));
                }

                Promise.all(promises).then(function (values) {
                    const result = values[0].data;
                    if (result.status === 'FAIL') {
                        vm.$router.push('/fitment/list');
                    }

                    vm.metalTypes = result.data.metalType;
                    if (values.length >= 2) {
                        vm.fitment = values[1].data;
                        vm.fitment.objectType = objectType;
                        if (vm.fitment.assetItemId) {
                            vm.fitment.parentId = vm.fitment.assetItemId;
                        } else if (vm.fitment.evlObjectId) {
                            vm.fitment.parentId = vm.fitment.evlObjectId;
                        }

                        if (vm.fitment.parentAppraisalStatusEnum) {
                            vm.status = vm.fitment.parentAppraisalStatusEnum;
                        } else if (vm.fitment.parentStatus) {
                            vm.status = vm.fitment.parentStatus;
                        }

                        vm.isPageLoadInit = false;
                    }
                    if (!vm.fitment.usdCurrencyRate) {
                        vm.fitment.usdCurrencyRate = result.data.usdRate;
                    }
                    if (!vm.fitment.eurCurrencyRate) {
                        vm.fitment.eurCurrencyRate = result.data.eurRate;
                    }
                    if (!vm.fitment.rubCurrencyRate) {
                        vm.fitment.rubCurrencyRate = result.data.rubRate;
                    }
                    if (!vm.fitment.vat) {
                        vm.fitment.vat = result.data.vat;
                    }
                    if (!vm.fitment.road) {
                        vm.fitment.road = result.data.road;
                    }
                    if (!vm.fitment.customsClearance) {
                        vm.fitment.customsClearance = result.data.customsClearance;
                    }
                    if (result.data.minSalary) {
                        vm.minSalary = result.data.minSalary;
                    }
                    vm.isNewStandard = result.data.isNewStandard;
                    if (!vm.fitment.productCategoryDto) {
                        vm.fitment.productCategoryDto = {
                            parent: {

                            }
                        };
                    }
                    if (vm.fitment.fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS') {
                        vm.changeDilapidationValue14();
                    } else if (vm.fitment.fitmentType === 'BUILDINGS_TRANSMITTERS_MACHINERY_EQUIPMENT') {
                        vm.changeDilapidationValue15();
                    }
                });
            },
            cancel() {
                if (this.fitment.objectType === 'Asset') {
                    this.$router.push('/asset/item/edit/' + this.fitment.parentId);
                } else if (this.fitment.objectType === 'Fitment') {
                    this.$router.push('/fitment/edit/' + this.fitment.parentId);
                }
            },
            save(type) {
                if (!this.fitment.dilapidationValue && this.fitment.fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS') {
                    this.fitment.dilapidationValue = 0;
                }
                console.log("this.$v", this.$v)
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;

                if (this.fitment.objectType === 'Asset') {
                    this.fitment.assetItemId = this.fitment.parentId;
                } else if (this.fitment.objectType === 'Fitment') {
                    this.fitment.evlObjectId = this.fitment.parentId;
                }

                this.$http.post('fitment/item/save', this.fitment)
                    .then(res => {
                        this.processing = false;

                        if (res.data.status !== "SUCCESS") {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t(res.data.message),
                                type: 'warning'
                            });
                            return;
                        }

                        this.fitment.id = res.data.data;

                        if (type === "SAVE_AND_CREATE_NEW") {
                            if (this.fitment.objectType === 'Asset') {
                                this.$router.push('/fitment/item/new/' + this.fitment.parentId + '/Asset');
                            } else if (this.fitment.objectType === 'Fitment') {
                                this.$router.push('/fitment/item/new/' + this.fitment.parentId + '/Fitment');
                            }
                        } else {
                            if (this.fitment.objectType === 'Asset') {
                                this.$router.push('/asset/item/edit/' + this.fitment.parentId);
                            } else if (this.fitment.objectType === 'Fitment') {
                                this.$router.push('/fitment/edit/' + this.fitment.parentId);
                            }
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            changeDilapidationValue15() {
                if (!this.fitment.dilapidationValue){
                    return;
                }
                if (this.fitment.dilapidationValue === 0 || this.fitment.dilapidationValue === 5) {
                    this.fitment.technicalCondition = 'New';
                    this.technicalConditionText = 'Янги';
                } else if (this.fitment.dilapidationValue === 10 || this.fitment.dilapidationValue === 15) {
                    this.fitment.technicalCondition = 'VeryGood';
                    this.technicalConditionText = 'Жуда яхши';
                } else if (this.fitment.dilapidationValue === 20 || this.fitment.dilapidationValue === 25 ||
                    this.fitment.dilapidationValue === 30 || this.fitment.dilapidationValue === 35) {
                    this.fitment.technicalCondition = 'Good';
                    this.technicalConditionText = 'Яхши';
                } else if (this.fitment.dilapidationValue === 40 || this.fitment.dilapidationValue === 45 ||
                    this.fitment.dilapidationValue === 50 || this.fitment.dilapidationValue === 55 || this.fitment.dilapidationValue === 60) {
                    this.fitment.technicalCondition = 'Satisfactory';
                    this.technicalConditionText = 'Қониқарли';
                } else if (this.fitment.dilapidationValue === 65 || this.fitment.dilapidationValue === 70 ||
                    this.fitment.dilapidationValue === 75 || this.fitment.dilapidationValue === 80) {
                    this.fitment.technicalCondition = 'ConditionallyAvailable';
                    this.technicalConditionText = 'Шартли равишда яроқли';
                } else if (this.fitment.dilapidationValue === 85 || this.fitment.dilapidationValue === 90) {
                    this.fitment.technicalCondition = 'Dissatisfied';
                    this.technicalConditionText = 'Қониқарсиз';
                } else if (this.fitment.dilapidationValue === 97.5 || this.fitment.dilapidationValue === 100) {
                    this.fitment.technicalCondition = 'ToBad';
                    this.technicalConditionText = 'Қўллашга яроқсиз';
                }
                this.calculated();
            },
            changeDilapidationValue14() {
                if (!this.fitment.dilapidationValue){
                    return;
                }

                if (this.fitment.dilapidationValue <= 80) {
                    if (this.fitment.dilapidationValue < 6) {
                        this.fitment.technicalCondition = 'New';
                        this.technicalConditionText = 'Янги';
                    } else if (this.fitment.dilapidationValue < 20) {
                        this.fitment.technicalCondition = 'VeryGood';
                        this.technicalConditionText = 'Жуда яхши';
                    } else if (this.fitment.dilapidationValue < 41) {
                        this.fitment.technicalCondition = 'Good';
                        this.technicalConditionText = 'Яхши';
                    } else if (this.fitment.dilapidationValue < 61) {
                        this.fitment.technicalCondition = 'Satisfactory';
                        this.technicalConditionText = 'Қониқарли';
                    } else if (this.fitment.dilapidationValue <= 80) {
                        this.fitment.technicalCondition = 'Dissatisfied';
                        this.technicalConditionText = 'Қониқарсиз';
                    }
                    this.calculated();
                } else {
                    this.fitment.dilapidationValue = 80;
                }
            },
            // getFitmentDataApi() {
            //     this.$eventBus.$emit('FitmentApiData', this.fitment);
            // },
            // clearAnalog() {
            //     this.fitment.qty = 0;
            //     this.fitment.dilapidationValue = null;
            //     this.fitment.governmentPrice = null;
            //     this.fitment.totalGovPrice = 0;
            //     this.fitment.apiData = false;
            //     this.fitment.unitMeasurementType = null;
            //     this.fitment.useWebSite = null;
            //     this.fitment.region = null;
            //     this.fitment.metalRate = 0;
            //     this.fitment.usdCurrencyRate = 0;
            //     this.fitment.metalTypeName = '';
            //     this.fitment.gramPriceInSum = 0;
            //     this.fitment.hallmark = null;
            //     this.fitment.weigh = null;
            //     this.fitment.stonePrice = null;
            //     this.fitment.overlayCoefficient = null;
            //     this.fitment.technicalCondition = null;
            //     this.fitment.stoneName = '';
            // },
            calculated() {
                const vm = this;
                if (vm.fitment.fitmentType !== 'JEWELRY') {
                    let rate = 1;
                    let usdPrice = vm.fitment.qty * vm.fitment.governmentPrice / vm.fitment.usdCurrencyRate;
                    if (vm.fitment.currency === "USD"){
                        rate = vm.fitment.usdCurrencyRate;
                        usdPrice = vm.fitment.qty * vm.fitment.governmentPrice;
                    } else if (vm.fitment.currency === "EUR") {
                        rate = vm.fitment.eurCurrencyRate;
                        usdPrice = vm.fitment.qty * vm.fitment.governmentPrice * rate / vm.fitment.usdCurrencyRate;
                    } else if (vm.fitment.currency === "RUB") {
                        rate = vm.fitment.rubCurrencyRate;
                        usdPrice = vm.fitment.qty * vm.fitment.governmentPrice * rate / vm.fitment.usdCurrencyRate;
                    }

                    let netAmount = vm.fitment.qty * vm.fitment.governmentPrice * rate;
                    if (vm.fitment.hasCustomsDuty) {
                        if (vm.isNewStandard) {
                            vm.getCoefficient(usdPrice);
                            vm.fitment.customsClearance = vm.coefficient * vm.minSalary;
                        }
                        if (!vm.isNewStandard) {
                            netAmount =
                                netAmount +
                                netAmount * (vm.fitment.vat + vm.fitment.road + vm.fitment.customsClearance + vm.fitment.customsDuty)/100;
                        } else {
                            netAmount =
                                netAmount + vm.fitment.customsClearance +
                                netAmount * (vm.fitment.vat + vm.fitment.road + vm.fitment.customsDuty)/100;
                        }
                    }
                    let dilapidationValue = vm.fitment.dilapidationValue ? vm.fitment.dilapidationValue : 0;
                    vm.fitment.totalGovPrice = (netAmount - (netAmount * (dilapidationValue / 100)));

                } else if (vm.fitment.metalType && vm.metalTypes.length > 0) {
                    for (let i = 0; i < vm.metalTypes.length; i++) {
                        let field = vm.metalTypes[i];
                        if (field.code === vm.fitment.metalType) {
                            vm.fitment.metalRate = field.rate;
                            vm.fitment.metalTypeName = field.displayName.toLowerCase();
                            vm.fitment.gramPriceInSum = (vm.fitment.metalRate / 31.1034769 * vm.fitment.usdCurrencyRate);
                            vm.fitment.governmentPrice = vm.fitment.gramPriceInSum * vm.fitment.hallmark * vm.fitment.weigh * vm.fitment.overlayCoefficient;
                            vm.fitment.totalGovPrice = vm.fitment.governmentPrice + vm.fitment.stonePrice;
                            vm.fitment.useWebSite = field.source;
                            vm.fitment.metalType = field.code;
                            vm.fitment.unitMeasurementType = "GRAM"
                        }
                    }
                }
            },
            onCategorySearch(searchTxt, loading) {
                loading(true);
                this.productCategoryFilter.search = searchTxt;
                this.searchMethod(loading);
            },
            onCategoryFocus() {
                this.productCategoryFilter.search = '';
                this.searchMethod();
            },
            searchMethod(loading) {
                this.productCategories = [];
                this.productSubCategories = [];
                this.productCategoryFilter.objectId = this.fitment.parentId;
                this.productCategoryFilter.objectType = this.fitment.objectType;
                this.productCategoryFilter.entiteCreateType = "INSIDE";
                this.$http.post('product-category/search', this.productCategoryFilter).then(res => {
                    if (loading)
                        loading(false);
                    this.productCategories = res.data.data;
                }, err => {
                    console.log(err);
                });
            },
            onSubCategorySearch(searchTxt, loading) {
                if (!this.fitment.productCategoryDto.parent) {
                    return;
                }
                loading(true);
                this.subCategoryFilter.search = searchTxt;
                this.subCategoryFilter.parentId = this.fitment.productCategoryDto.parent.id;
                this.searchMethodSub(loading);
            },
            onSubCategoryFocus() {
                if (!this.fitment.productCategoryDto.parent) {
                    return;
                }
                this.subCategoryFilter.search = '';
                this.subCategoryFilter.parentId = this.fitment.productCategoryDto.parent.id;
                this.searchMethodSub();
            },
            searchMethodSub(loading) {
                this.productSubCategories = [];
                this.subCategoryFilter.objectId = this.fitment.parentId;
                this.subCategoryFilter.objectType = this.fitment.objectType;
                this.subCategoryFilter.entiteCreateType = "INSIDE";
                this.$http.post('product-category/search-sub', this.subCategoryFilter)
                    .then(res => {
                        if (loading)
                            loading(false);
                        this.productSubCategories = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onChangeMethod() {
                this.fitment.productCategoryDto = {
                    parent:this.fitment.productCategoryDto.parent
                };
            },
            onChangeMethodSub() {
                if (!this.fitment.productCategoryDto.hasManufacturer) {
                    this.fitment.brandName = null;
                }
                if (!this.fitment.productCategoryDto.hasMadeYear) {
                    this.fitment.madeYear = null;
                }
                if (!this.fitment.productCategoryDto.hasModel) {
                    this.fitment.model = null;
                }
                if (this.fitment.productCategoryDto.fitmentType) {
                    this.fitment.fitmentType = this.fitment.productCategoryDto.fitmentType;
                    this.fitment.customsDuty = this.fitment.productCategoryDto.customsDuty;
                    this.calculated();
                }
            },
            getCoefficient(usdPrice) {
                if (usdPrice < 10000) {
                    this.coefficient = 1;
                } else if (usdPrice < 20000) {
                    this.coefficient = 1.5;
                } else if (usdPrice < 40000) {
                    this.coefficient = 2.5;
                } else if (usdPrice < 60000) {
                    this.coefficient = 4;
                } else if (usdPrice < 100000) {
                    this.coefficient = 8;
                } else if (usdPrice < 200000) {
                    this.coefficient = 15;
                } else if (usdPrice < 500000) {
                    this.coefficient = 30;
                } else if (usdPrice < 1000000) {
                    this.coefficient = 58;
                } else {
                    this.coefficient = 75;
                }
            }
        },
        created() {
            // const id = this.$props.id;
            // if (id && id > 0) {
                this.init();
            // }
            this.$eventBus.$on('FitmentItemEdit', (data) => {
                if (data && data.apiData) {
                    this.fitment.name = data.name;
                    this.fitment.governmentPrice = data.price;
                    let um = null;
                    for (let i = 0; i < this.unitMeasurements.length; i++) {
                        if (data.unitMeasurementType.id === this.unitMeasurements[i].code) {
                            um = this.unitMeasurements[i].key;
                        }
                    }
                    this.fitment.unitMeasurementType = um;
                    this.fitment.useWebSite = "www.oling.uz";

                }
            });
        }
    }
</script>

<style scoped>
    .calculate{
        border: 1px solid #9A9A9A;
        padding: 10px;
        font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
        color: #9A9A9A;
    }
</style>